module.exports = __webpack_public_path__ + "i18n/languages.5d37f57.json";